import { Injectable } from '@angular/core';
import { UserData } from 'src/app/data/user.data';
import { NotificationsData } from './notifications.data';

@Injectable({ providedIn: 'root' })
export class DataServices {
  constructor(private notifications: NotificationsData, private userData: UserData) {}
  dispose() {
    const promises = [this.notifications.dispose(), this.userData.dispose()];
    return Promise.all(promises.map(p => p.catch((e: unknown) => e)));
  }
}
